module.exports = __webpack_public_path__ + "static/media/BJ.e3f47e09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BJ.svg
// module id = 206
// module chunks = 0